import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store';
import { closeModal } from '@/store/slices/modalSlice';
import LoginModal from './LoginModal';
import SignupModal from './SignupModal';
import WelcomeBannerModal from './WelcomeBannerModal';
import ForgotPasswordModal from './ForgotPasswordModal';

const ModalManager: React.FC = () => {
  const dispatch = useDispatch();
  const { activeModal } = useSelector((state: RootState) => state.modal);

  const handleClose = () => dispatch(closeModal());

  return (
    <>
      <LoginModal isOpen={activeModal === 'login'} onClose={handleClose} />
      <SignupModal isOpen={activeModal === 'register'} onClose={handleClose} />
      <WelcomeBannerModal isOpen={activeModal === 'welcomeBanner'} onClose={handleClose} />
      <ForgotPasswordModal isOpen={activeModal === 'forgotPassword'} onClose={handleClose} />
    </>
  );
};

export default ModalManager;
